<template>
  <div>
    <div class="thank-you-container">
      <p style="font-weight: 600; font-size: 35px; color: #00346b; margin: 0px 0px 20px">
        Thank you for supporting Teach Coalition.
      </p>
      <p style="margin: 0px 0px 20px">
        Your generous support fuels our advocacy for government funding to give our
        children a safe, strong and affordable Jewish education.
      </p>
      <p style="margin: 0px 0px 20px">
        Across our five states, more than $355 million a year is funding scholarships,
        STEM education, security, technology, and so much more that helps our families and
        schools.
      </p>
      <p style="margin: 0px 0px 20px">
        Your support strengthens the advocacy that is needed in the fight for equitable
        funding of our children’s education.
      </p>
      <p style="margin: 0px 0px 20px">
        Thank you for your commitment to Teach Coalition and to the affordable education
        of more than 200,000 Jewish students across the country.
      </p>
    </div>
  </div>
</template>
<style scoped>
.thank-you-container {
  padding: 20px;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
}
</style>
